import { Injectable } from "@angular/core";

import { GroupSearchCriteria } from "@models/GroupSearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class GroupSearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<GroupSearchCriteria> {
    const criteria = await this.ps.getGroupSearchCriteria();
    return criteria;
  }
}
